import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_MOCKS } from '../../Utils/apis';
import { addMocks } from '../../Store/Slices/mocks';

const useFetchMultipleMocks = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mocks, setMocks] = useState([]);
  const Candidate_Id = useSelector(store => store?.user?.candidate_id);
  // console.log("Candidate_Id from Redux:", Candidate_Id);
  const isExisted = useSelector(store => Object.keys(store?.mocks).length > 0 ? true : false);
  const dispatch = useDispatch();

  const fn = async () => {  // New: Optional force param
    if (!loading && Candidate_Id && !isExisted) {  // Bypass !isExisted if force=true
      // console.log("Fetching mocks for candidate:", Candidate_Id);
      try {
        setLoading(true);
        // console.log("Making API call to fetch mocks...");
        const res = await fetch(FETCH_MOCKS , {
          method: 'GET',
          credentials: 'include',
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.error);
        }
        const data = await res.json();
        // console.log(data);
        dispatch(addMocks(data?.data?.mockData || []));  // Store in Redux
        setMocks(data);
      } catch (error) {
        setError(error.message);
        return Promise.reject(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   fn();  // Initial fetch (no force)
  // }, [Candidate_Id]);

  return [loading, error, mocks, fn];
};

export default useFetchMultipleMocks;
